import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="chars-left"
export default class extends Controller {
  static targets = [ "input", "hint" ]
  static values = {
    maxChars: Number
  }

  connect() {
    this.updateCharsLeft()
    this.inputTarget.dataset.action += " input->chars-left#updateCharsLeft"
  }

  updateCharsLeft() {
    const input = this.inputTarget
    const maxChars = this.maxCharsValue
    const charsLeft = maxChars - input.value.length
    this.hintTarget.textContent = `${charsLeft} characters left`
  }
}
